import { useEffect, useState } from "react";

const GridIMG = () => {
  const basePath = `${process.env.PUBLIC_URL}/image/grid`;
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 800);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 800);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const imagePaths = Array.from(
    { length: isMobile ? 6 : 5 }, // 모바일 6개, PC 5개
    (_, i) => `${basePath}/grid_${i + 1}.png`
  );

  // 🟢 PC일 때 이미지 순서 재정렬
  if (!isMobile) {
    imagePaths.sort((a, b) => {
      const order = [2, 3, 4, 1, 5]; // 원하는 순서
      const aIndex = order.indexOf(parseInt(a.match(/grid_(\d+)/)[1]));
      const bIndex = order.indexOf(parseInt(b.match(/grid_(\d+)/)[1]));
      return aIndex - bIndex;
    });
  }
  // 🟢 PC & 모바일 각각 스크롤 이동할 ID 설정
  const pcScrollTargets = ["image-6", "image-7", "image-8", "image-4", "1-9"];
  const mobileScrollTargets = [
    "image-9",
    "image-6",
    "image-7",
    "image-8",
    "1-9",
    "1-10",
  ];

  // 🟢 현재 기기 상태에 맞는 스크롤 타겟 배열 선택
  const scrollTargets = isMobile ? mobileScrollTargets : pcScrollTargets;

  // 🟢 특정 요소로 스크롤 이동
  const handleScrollTo = (targetId) => {
    if (!targetId) return; // ⛔ 유효하지 않은 ID 클릭 방지

    const target = document.getElementById(targetId);
    if (target) {
      const offset = isMobile ? 150 : 80; // 네비게이션 바 고려
      const targetPosition =
        target.getBoundingClientRect().top + window.scrollY - offset;

      window.scrollTo({
        top: targetPosition,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="grid-container">
      {imagePaths.map((src, index) => (
        <img
          key={index}
          src={src}
          alt={`Grid Image ${index + 1}`}
          onClick={() => handleScrollTo(scrollTargets[index])} // 클릭 시 스크롤 이동
          className={scrollTargets[index] ? "clickable" : "disabled"} // ⛔ 없는 ID에 대한 클릭 방지
        />
      ))}
      <style jsx>{`
        .grid-container {
          display: flex;
          justify-content: center;
          gap: 0px; /* 기본 간격 */
          margin-top: 20px;
          padding: 0 0 70px;
        }

        .grid-container img {
          width: 280px; /* 기본 이미지 크기 */
          height: auto;
          cursor: pointer; /* 클릭 가능 표시 */
          transition: transform 0.3s ease;
        }

        .grid-container img:hover {
          transform: scale(1.05); /* 호버 시 확대 */
        }

        .disabled {
          pointer-events: none; /* ⛔ 클릭 불가능하게 설정 */
          opacity: 0.5; /* 비활성화 표시 */
        }

        @media (max-width: 800px) {
          .grid-container {
            flex-wrap: wrap; /* 한 줄에 2개씩 */
            justify-content: center;
          }

          .grid-container img {
            width: calc(45% - 10px); /* 한 줄에 2개씩 나오도록 */
          }
        }
      `}</style>
    </div>
  );
};

export default GridIMG;
